import styled from 'styled-components'

export const FormContainer = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`
